<template>
  <div style="margin-bottom: 50px">
    <div style="margin: 0 6px 10px 6px;">
      <el-date-picker
        v-model="date"
        :clearable="false"
        type="date"
        style="position: relative; top: 1px"
        @change="changeDate">
      </el-date-picker>
      <el-input prefix-icon="el-icon-search"
                clearable
                v-model="searchText"
                style="width: 260px; margin-left: 10px;"
                placeholder="技师/服务顾问">
      </el-input>
      <el-button style="margin-left: 10px" @click="changeDate">查询</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border :cell-style="cellStyle" header-cell-class-name="table-head">
      <el-table-column fixed
                       prop="technicianName"
                       label="技师"
                       width="100">
      </el-table-column>
      <el-table-column :width="timeColumnWidth" :resizable="false" align="center" v-for="(timeLabel, index) in timeList"
                       :label="timeLabel" :key="index">
        <template #default="{ row }">
          <div style="width: 100%; height: 100%; display: flex;">
            <div
              class="empty-border"
              :class="{'empty-cell': !row.plan[index][0], 'fill-cell': row.plan[index][0],'fill-border': row.plan[index][0]&&row.plan[index][1]}"></div>
            <div
              class="empty-border"
              :class="{'empty-cell': !row.plan[index][1], 'fill-cell': row.plan[index][1],'fill-border': row.plan[index][1]&&row.plan[index][1]}"></div>
            <div
              class="empty-border"
              :class="{'empty-cell': !row.plan[index][2], 'fill-cell': row.plan[index][2],'fill-border': row.plan[index][2]&&row.plan[index][3]}"></div>
            <div :class="{'empty-cell': !row.plan[index][3], 'fill-cell': row.plan[index][3]}"></div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { technicianWorkPlanList } from '@/utils/request'
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'TechnicianLoad',
    mixins: [resizeCaptureMixin],
    data () {
      return {
        loading: false,
        date: new Date(),
        searchText: null,
        timeList: ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'],
        technicianPlanList: []
      }
    },
    created () {
      this.changeDate()
    },
    methods: {
      cellStyle ({ row, column, rowIndex, columnIndex }) {
        if (columnIndex > 0 && columnIndex < this.timeList.length) {
          if (row.plan[columnIndex - 1][3] && row.plan[columnIndex][0]) {
            return { 'border-right-color': '#8fb4e2' }
          }
        }
      },
      changeDate () {
        this.loading = true
        technicianWorkPlanList(this.date.format('yyyy-MM-dd')).then(response => {
          this.timeList = response.data.timeList
          this.technicianPlanList = response.data.technicianPlanList
        }).finally(() => {
          this.loading = false
        })
      }
    },
    computed: {
      tableData () {
        if (!this.searchText) {
          return this.technicianPlanList
        }
        return this.technicianPlanList.filter(technician => {
          return technician.technicianName.indexOf(this.searchText) !== -1
        })
      },
      timeColumnWidth () {
        return Math.max(116, (this.clientWidth - 110) / this.timeList.length)
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    // 表头
    th {
      font-weight: bold;
    }

    .el-table--small th, .el-table--small td {
      padding: 2px 0;
      font-weight: bold;
    }

    .el-table--small td, .el-table .cell {
      padding: 0 !important;
      height: 28px;
    }

    // 表格元素内文字居中
    .cell {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .empty-cell {
      background: transparent;
      flex-grow: 1;
    }

    .fill-cell {
      background: #8fb4e2;
      flex-grow: 1;
    }

    .empty-border {
      border-right: 1px solid #dfdfe2;
    }

    .fill-border {
      border-right: 1px solid #8fb4e2 !important;
    }
  }
</style>
